import React, { useState, useEffect, useRef } from "react";
import "./EmployeesAttendanceReport.css";
import ExcelJS from "exceljs";

import Select from "react-select";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDaysInMonth } from "../../../utils/calculateDaysInMonthUtils";
import { capitalizeFirstLetter } from "../../../utils/validations";
import DatePicker from 'react-datepicker';
import { getDistrict, getStates, fetchMonths } from '../../../services/monthlyAttendanceService';

import {  getDesignationsPriority} from "../../../services/employeeCreationService";


const EmployeesAttendance = () => {
  const effectRan = useRef(false);
  const [state, setState] = useState(3);
  const [district, setDistrict] = useState(null);
  const [month, setMonth] = useState(new Date().getMonth()+1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [stateId, setStateId] = useState(null);
  const [districtId, setDistrictId] = useState(null);
  const [monthOptions, setMonthOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);

  const [attendanceData, setAttendanceData] = useState([]);
  const [selectedMonthYear, setSelectedMonthYear] = useState(null);

  const isFetchDataEnabled = state && month && year;
  const today = new Date();
  const currentDay = today.getDate();
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();
  //const currentYear = new Date().getFullYear();
  const minDate = new Date(2000, 0, 1);
  const maxDate = new Date(currentYear, 11, 31);
 const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [designations, setDesignations] = useState([]);
  const [isFocused, setIsFocused] = useState({
    state: false,
    district: false,
    month: false,
    year: false,
    designations: false,
  });
  const [errors, setErrors] = useState({});
  const yearInputRef = useRef(null);
  const days = month && year ? getDaysInMonth(month, year) : 0;


// Fetch states
useEffect(() => {
  const fetchStates = async () => {
    try {
      const data = await getStates();

      const sortedStates = data
        .sort((a, b) => a.stateName.localeCompare(b.stateName)) // Alphabetical sort
        .map(item => ({
          value: item.id,
          label: capitalizeFirstLetter(item.stateName),
        }));

      setStateOptions(sortedStates);
    } catch (error) {
      console.error('Error fetching states:', error);
      setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
    }
  };

  if (!effectRan.current) {
    fetchStates();
  }
  return () => {
    effectRan.current = true;
  };
}, []);


  useEffect(() => {
    const loadMonths = async () => {
      try {
        const months = await fetchMonths(year);

        // ✅ Ensure current month is included in the list
        const today = new Date();
        const currentMonthValue = today.getMonth() + 1; // 1-based
        const monthExists = months.some(m => m.value === currentMonthValue);
        if (!monthExists && year === today.getFullYear()) {
          months.push({ value: currentMonthValue, label: today.toLocaleString('default', { month: 'long' }) });
          months.sort((a, b) => a.value - b.value); // optional, to keep months in order
        }

        setMonthOptions(months);
      } catch (error) {
        console.error("Error fetching months:", error);
        setErrors(prev => ({ ...prev, general: "Failed to load months" }));
      }
    };
    loadMonths();
  }, [year]);


 // Fetch districts when state changes
useEffect(() => {
  if (state) {
    const fetchDistricts = async () => {
      try {
        const data = await getDistrict(state);

        const sortedDistricts = data
          .sort((a, b) => a.districtName.localeCompare(b.districtName)) // alphabetical sort
          .map(item => ({
            value: item.districtId,
            label: item.districtName,
          }));

        setDistrictOptions(sortedDistricts);
      } catch (error) {
        console.error('Error fetching districts:', error);
        setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
      }
    };

    fetchDistricts();
  } else {
    setDistrictOptions([]);
    setDistrict(null);
  }
}, [state]);


 // Fetch designations
useEffect(() => {
    const fetchDesignation = async () => {
        try {
            const data = await getDesignationsPriority();
            if (Array.isArray(data)) {

                const sortedData = data
                    .sort((a, b) => a.designationName.localeCompare(b.designationName))
                    .map((d) => ({
                        value: d.id,
                        label: d.designationName,
                    }));

                setDesignations(sortedData);
            } else {
                console.error("Invalid response: designations should be an array");
            }
        } catch (err) {
            console.error("Error fetching designation:", err);
        }
    };

    if (effectRan.current === false) {
        fetchDesignation();
    }
    return () => {
        effectRan.current = true;
    };
}, []);


  const handleYearChange = (date) => {
    setYear(date ? date.getFullYear() : null);
    setErrors(prev => ({ ...prev, year: null }));
  };

  const isCurrentMonth =
    (!selectedMonthYear &&
      today.getMonth() + 1 === currentMonth &&
      today.getFullYear() === currentYear) ||
    (selectedMonthYear &&
      parseInt(selectedMonthYear.value.split("-")[1]) === currentMonth &&
      parseInt(selectedMonthYear.value.split("-")[0]) === currentYear);


  const handleInputChange = (selectedOption, field) => {
    const value = selectedOption ? selectedOption.value : null;
    switch (field) {
      case 'state':
        setState(value);
        setStateId(value);
        setDistrict(null);
        setMonth(null);

        break;
      case 'district':
        setDistrict(value);
        setDistrictId(value);
        break;
      case 'month':
        setMonth(value);
        break;
      case 'designations':
        setSelectedDesignation(value);
        break;

      default:
        break;
    }
    setErrors(prev => ({ ...prev, [field]: null }));
  };
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/attendance/monthlyReport?stateId=${state}&districtId=${district || ""}&year=${year}&month=${month}&designationId=${selectedDesignation || ""}`
    );
    const data = await response.json();

    // ✅ Transform data into grouped employee objects
    const groupedData = data.reduce((acc, item) => {
      const { employeeId, fullName, designation, districtName, attendanceDate, status } = item;
      const day = new Date(attendanceDate).getDate().toString();

      if (!acc[employeeId]) {
        acc[employeeId] = {
          employeeId,
          fullName,
          designation,
          districtName,
          dayWiseStatus: {},
          presentDays: 0,
          absentDays: 0,
          payableDays: 0,
        };
      }

      acc[employeeId].dayWiseStatus[day] = status;

      // ✅ Count only relevant statuses
      if (status === "Present") acc[employeeId].presentDays++;
      if (status === "Absent") acc[employeeId].absentDays++;
      if (["Present", "Holiday", "Week Off"].includes(status)) acc[employeeId].payableDays++;

      return acc;
    }, {});

    // ✅ Set the final structured array
    setAttendanceData(Object.values(groupedData));

  } catch (error) {
    console.error("Error fetching attendance data:", error);
  }
};

  // 🔹 Excel Download
  const generateExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Attendance");

    // Get filter labels
    const stateLabel = stateOptions.find(opt => opt.value === state)?.label || "";
    const districtLabel = districtOptions.find(opt => opt.value === district)?.label || "";
    const monthYearLabel = `${monthOptions.find(opt => opt.value === month)?.label || "N/A"}-${year || "N/A"}`;


    // Title
    worksheet.mergeCells("A1:AL1");
    const titleCell = worksheet.getCell("A1");
    titleCell.value = "Monthly Attendance Report";
    titleCell.font = { bold: true, size: 16 };
    titleCell.alignment = { horizontal: "center" };

    // Filters in merged row
    worksheet.mergeCells("A2:AL2");
    const filterCell = worksheet.getCell("A2");
    filterCell.value = `State: ${stateLabel}   |   District: ${districtLabel}   |   Month-Year: ${monthYearLabel}`;
    filterCell.alignment = { horizontal: "left" }; // make it centered across merged cells
    filterCell.font = { bold: true, size: 12 };

    // Table headers
    const headers = [
      "S.No",
      "District",
      "EmployeeId",
      "Employee Name",
      "Designation",
      ...Array.from({ length: days }, (_, i) => `${i + 1}`),
      "Present",
      // "Casual Leave",
      "Absent",
      "Total No.of Days Payable",
    ];

    worksheet.addRow(headers);

    // Style headers
    const headerRow = worksheet.getRow(worksheet.lastRow.number);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF4F81BD" },
      };
      cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Add rows from attendanceData
    attendanceData.forEach((emp, index) => {
      const row = [
        index + 1,
        emp.districtName || "",
        emp.employeeId || "",
        emp.fullName || "",
        emp.designation || "",
        ...Array.from({ length: days }, (_, i) => {
          const day = (i + 1).toString();
          const status = emp.dayWiseStatus?.[day] || "";

          // ✅ Convert N / NA / Not Marked / null to blank
          return ["N", "NA", "Not Marked", null, "", undefined].includes(status)
            ? "-"
            : status.charAt(0);
        }),
        emp.presentDays || 0,
        // emp.casualLeaveDays || 0,
        emp.absentDays || 0,
         emp.payableDays || 0,
      ];
      worksheet.addRow(row);
    });

    // Auto adjust column widths
    worksheet.columns.forEach((column, index) => {
      let maxLength = 7;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const columnLength = cell.value ? cell.value.toString().length : 5;
        if (columnLength > maxLength) maxLength = columnLength;
      });

      if (index < 5) {
        // Limit first 4 columns to max width 20
        column.width = Math.min(maxLength + 3, 20);
      } else if (index >= 4 && index < 4 + days) {
        // Day columns → fixed small width
        column.width = 5;
      } else {
        // Summary columns → auto width
        column.width = Math.min(maxLength + 3, 15);
      }
    });


    // Download Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Monthly_Attendance_${monthYearLabel}.xlsx`;
    link.click();
  };


  const generatePDF = () => {
    // if (attendanceData.length === 0) {
    //   alert("No data to export");
    //   return;
    // }

    const doc = new jsPDF("l", "pt", "a3"); // Landscape, bigger size (A3) for many columns

    // Title
    doc.setFontSize(16);
    doc.text("Daily Attendance Report", 40, 30);

    // Get selected filters
    const stateLabel = stateOptions.find(opt => opt.value === state)?.label || "";
    const districtLabel = districtOptions.find(opt => opt.value === district)?.label || "";

    const monthYearLabel = `${monthOptions.find(opt => opt.value === month)?.label || "N/A"}-${year || "N/A"}`;


    // Print filters
    doc.setFontSize(11);
    doc.text(`State: ${stateLabel}`, 40, 50);
    doc.text(`District: ${districtLabel}`, 250, 50);
    doc.text(`Month-Year: ${monthYearLabel}`, 40, 65);

    // Dynamic columns: District, EmployeeId, Employee Name, Designation, days..., Present, CL, Absent, Payable
    const tableColumn = [
      "S.No",
      "District",
      "EmployeeId",
      "Employee Name",
      "Designation",
      ...Array.from({ length: days }, (_, i) => `${i + 1}`),
      "Present",
      "Absent",
      "Total No.of Days Payable",
    ];

    // Table rows
    const tableRows = attendanceData.map((emp, index) => {
      const row = [
        index + 1,
        emp.districtName || "",
        emp.employeeId || "",
        emp.fullName || "",
        emp.designation || "",
        ...Array.from({ length: days }, (_, i) => {
          const day = (i + 1).toString();
          const status = emp.dayWiseStatus?.[day] || "";

          // ✅ Convert N / NA / Not Marked / null to blank
          return ["N", "NA", "Not Marked", null, "", undefined].includes(status)
            ? "-"
            : status.charAt(0);
        }),
        emp.presentDays || 0,
        // emp.casualLeaveDays || 0,
        emp.absentDays || 0,
           emp.payableDays || 0,
      ];
      return row;
    });

    // Generate table
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 80,
      styles: { fontSize: 7 }, // smaller font to fit
      headStyles: { fillColor: [79, 129, 189], textColor: 255 },
      margin: { left: 40, right: 40 },
      tableWidth: "auto",
    });

    doc.save(`Monthly_Attendance_${monthYearLabel}.pdf`);
  };

  
  return (
    <div className="employee-attendance-main">
      <div className="employee-attendance-head">
        {/* <h5>Daily Attendance Report</h5> */}
        <div className="employee-attendance-box">
          <h2 className="employee-attendance-heading">Daily Attendance Report</h2>
          {errors.general && <div className="error-message">{errors.general}</div>}
          <form onSubmit={handleSubmit} >
            <div className="employee-attendance-maincontainer">
              <div className="employee-attendance-container-part">
                <div className={`employee-attendance-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                  <Select
                    name="state"
                    options={stateOptions}
                    value={stateOptions.find(opt => opt.value === state) || null}
                    onChange={option => handleInputChange(option, 'state')}
                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                    placeholder=" "
                    isClearable
                    menuPortalTarget={document.body}
                    styles={selectStyles}

                  />
                  <label><span className="required">*</span>State</label>
                  {errors.state && <div className="error-message">{errors.state}</div>}
                </div>
              </div>
              <div className="employee-attendance-container-part">
                <div className={`employee-attendance-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                  <Select
                    name="district"
                    options={districtOptions}
                    value={districtOptions.find(opt => opt.value === district) || null}
                    onChange={option => handleInputChange(option, 'district')}
                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                    placeholder=" "
                    isClearable
                    menuPortalTarget={document.body}
                    styles={selectStyles}

                  />
                  <label>District</label>
                  {errors.district && <div className="error-message">{errors.district}</div>}
                </div>
              </div>
            </div>
            <div className="employee-attendance-maincontainer">
              <div className="employee-attendance-container-part">
                <div className={`employee-attendance-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                  <DatePicker
                    selected={year ? new Date(year, 0, 1) : null}
                    onChange={handleYearChange}
                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                    dateFormat="yyyy"
                    showYearPicker
                    placeholderText=""
                    className="employee-attendance-date-picker"
                    minDate={minDate}
                    maxDate={maxDate}
                    ref={yearInputRef}
                    title="Select a year"
                  />
                  <label><span className="required">*</span>Year</label>
                  {errors.year && <div className="error-message">{errors.year}</div>}
                </div>
              </div>
              <div className="employee-attendance-container-part">
                <div className={`employee-attendance-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                  <Select
                    name="month"
                    options={monthOptions}
                    value={monthOptions.find(opt => opt.value === month) || null}
                    onChange={option => handleInputChange(option, 'month')}
                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                    placeholder=" "
                    isClearable
                    menuPortalTarget={document.body}
                    styles={selectStyles}
                  />
                  <label><span className="required">*</span>Month</label>
                  {errors.month && <div className="error-message">{errors.month}</div>}
                </div>
              </div>
              
            </div>

             <div className="employee-attendance-maincontainer">
                            <div className="employee-attendance-container-part">
                                <div className={`employee-attendance-floating-label-container ${isFocused.selectedDesignation||selectedDesignation ? 'float-label' : ''}`}>
                                    <Select
                                        options={designations}
                                        value={designations.find((option) => option.value === selectedDesignation) || null}
                                        onChange={(selectedOption) => handleInputChange(selectedOption, 'designations')}
                                        placeholder=""
                                        isClearable
                                        menuPortalTarget={document.body}
                                        // styles={{
                                        //     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        //     control: (provided) => ({
                                        //         ...provided,
                                        //         backgroundColor: "#fff",
                                        //         borderColor: "#c9c9c9",
                                        //     }),
                                        //     singleValue: (provided) => ({ ...provided, color: "#474747" }),
                                        // }}
                                        styles={selectStyles}
                                    />
                                    <label>Designation</label>
                                    {/* {errors.jobPosition && <p className="error">{errors.jobPosition}</p>} */}
                                </div>
                            </div>
                            <div className="employee-attendance-container-part">
                             
                            </div>
                        </div>
            <div className="employee-attendance-btn-div">
              <button type="submit" className="employee-attendance-btn"
                disabled={!isFetchDataEnabled}

              >
                Generate Report
              </button>
            </div>
          </form>
        </div>


        <div className="daily-gen-button">
          <button
            className="employee-attendance-downloadexcel"
            onClick={generatePDF}
            disabled={attendanceData.length === 0} // ✅ Disable if no data
          >
            Download PDF
          </button>
          <button
            className="employee-attendance-downloadexcel"
            onClick={generateExcel}
            disabled={attendanceData.length === 0} // ✅ Disable if no data
          >
            Download Excel
          </button>
        </div>

        <div className="employee-attendance-div">


          <div className="table-scroll-wrapper">
            <table className="employee-attendance-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>District</th>
                  <th>EmployeeId</th>
                  <th>Employee Name</th>
                  <th>Designation</th>

                  {Array.from({
                    length: getDaysInMonth(month || currentMonth, year || currentYear)
                  }, (_, i) => {
                    const dayNum = i + 1;

                    const defaultMonth = month || currentMonth;
                    const defaultYear = year || currentYear;

                    const isPast = defaultMonth === currentMonth && defaultYear === currentYear && dayNum < currentDay;
                    const isToday = defaultMonth === currentMonth && defaultYear === currentYear && dayNum === currentDay;

                    return (
                      <th
                        key={dayNum}
                        style={{
                          backgroundColor: isToday ? "lightgreen" : undefined,
                          color: isPast ? "gray" : undefined,
                          pointerEvents: isPast ? "none" : "auto",
                        }}
                      >
                        {dayNum}
                      </th>
                    );
                  })}

                  <th>Present</th>
                  {/* <th>Casual Leave</th> */}
                  <th>Absent</th>
                  <th>Total No.of Days Payable</th>
                </tr>
              </thead>

              <tbody>
                {attendanceData.map((employee, index) => {
                  const minDay = Math.min(...Object.keys(employee.dayWiseStatus).map(Number));

                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{employee.districtName}</td>
                      <td>{employee.employeeId}</td>
                      <td>{employee.fullName}</td>
                      <td>{employee.designation}</td>

                      {Array.from({ length: days }, (_, dayIndex) => {
                        const day = (dayIndex + 1).toString();
                        const status = employee.dayWiseStatus[day] || "";

                        const isToday =
                          month === currentMonth &&
                          year === currentYear &&
                          dayIndex + 1 === currentDay;

                        const isPast =
                          month === currentMonth &&
                          year === currentYear &&
                          dayIndex + 1 < currentDay;

                        const isFuture =
                          month === currentMonth &&
                          year === currentYear &&
                          dayIndex + 1 > currentDay;

                        return (
                          <td
                            key={dayIndex}
                            style={{
                              backgroundColor: isToday
                                ? "lightgreen"    // ✅ Today
                                : isFuture
                                  ? "#f2f2f2"      // ✅ Future
                                  : "white",  // ✅ Past (default for rest)
                              pointerEvents: "none",
                            }}
                          >
                            {["N", "NA", "Not Marked", null, "", undefined].includes(status)
                              ? "-"
                              : status.charAt(0)} {/* ✅ Blank if no status */}
                          </td>
                        );
                      })}


                      <td>{employee.presentDays}</td>
                      {/* <td>{employee.presentDays}</td> */}
                      <td>{employee.absentDays}</td>
                      <td>{employee.payableDays}</td>
                    </tr>
                  );
                })}
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeesAttendance;
